// Hockey nations for Olympics and World Championships
// Using ISO 3166-1 alpha-3 codes for consistency

export interface HockeyNation {
  code: string;
  name: string;
  flag: string;
}

export const hockeyNations: HockeyNation[] = [
  { code: "CAN", name: "Canada", flag: "🇨🇦" },
  { code: "USA", name: "United States", flag: "🇺🇸" },
  { code: "SWE", name: "Sweden", flag: "🇸🇪" },
  { code: "FIN", name: "Finland", flag: "🇫🇮" },
  { code: "RUS", name: "Russia", flag: "🇷🇺" },
  { code: "CZE", name: "Czechia", flag: "🇨🇿" },
  { code: "CHE", name: "Switzerland", flag: "🇨🇭" },
  { code: "DEU", name: "Germany", flag: "🇩🇪" },
  { code: "SVK", name: "Slovakia", flag: "🇸🇰" },
  { code: "LVA", name: "Latvia", flag: "🇱🇻" },
  { code: "DNK", name: "Denmark", flag: "🇩🇰" },
  { code: "NOR", name: "Norway", flag: "🇳🇴" },
  { code: "FRA", name: "France", flag: "🇫🇷" },
  { code: "AUT", name: "Austria", flag: "🇦🇹" },
  { code: "KAZ", name: "Kazakhstan", flag: "🇰🇿" },
  { code: "BLR", name: "Belarus", flag: "🇧🇾" },
  { code: "GBR", name: "Great Britain", flag: "🇬🇧" },
  { code: "HUN", name: "Hungary", flag: "🇭🇺" },
  { code: "ITA", name: "Italy", flag: "🇮🇹" },
  { code: "POL", name: "Poland", flag: "🇵🇱" },
  { code: "SVN", name: "Slovenia", flag: "🇸🇮" },
  { code: "JPN", name: "Japan", flag: "🇯🇵" },
  { code: "KOR", name: "South Korea", flag: "🇰🇷" },
  { code: "CHN", name: "China", flag: "🇨🇳" },
];

export const getNationByCode = (code: string | null): HockeyNation | undefined => {
  if (!code) return undefined;
  return hockeyNations.find((n) => n.code === code);
};
